import { Modal, formatDateTime, Combobox, GetItemsProps } from 'medere-ui-framework'
import { Divider } from 'primereact/divider';
import { Dropdown } from 'primereact/dropdown';
import { Button } from 'primereact/button';
import LinedCard from '../../components/InfoCard/LinedCard'
import { ProfessionalAttentionLogDetailDTO, ProfessionalAttentionLogNomenclatorDTO } from '../../dto/homeHospitalization/ProfessionalAttentionLogDetailDTO';
import { useIntl } from 'react-intl';
import GoogleMap from '../../components/GoogleMap';
import "./HomeHospitalization.scss"
import { InputTextarea } from 'primereact/inputtextarea'
import { useState, useEffect } from 'react'
import { getAuditStates, updateAuditState, updateAttentionPractices, loadProfessionalAttentionLogDetail } from '../../servicesHooks/HomeHospitalization/useHomeHospitalizationService'
import { NomenclatorDTO } from '../../dto/NomenclatorDTO'
import { useHonorariumService } from '../../servicesHooks/Honorarium/useHonorariumService';
import { useEntityService } from '../../servicesHooks/Entity/useEntityService';

interface AttentionReportModalProps {
    visible: boolean;
    setVisible: (open: boolean) => void;
    showHonorarium: boolean | null;
    data: ProfessionalAttentionLogDetailDTO;
    onAuditStateUpdated?: () => void;
    mode?: 'view' | 'audit' | 'editAudit';
}

export default function AttentionReportModal({ visible, setVisible, showHonorarium, data, onAuditStateUpdated, mode = 'view' }: AttentionReportModalProps) {
    const intl = useIntl();
    const [observations, setObservations] = useState('')
    const [auditStates, setAuditStates] = useState<any[]>([])
    const [selectedAuditState, setSelectedAuditState] = useState<any>(null)
    const [modifiedPractices, setModifiedPractices] = useState<{[key: number]: ProfessionalAttentionLogNomenclatorDTO & { honorarium?: number }}>({});
    const [detail, setDetail] = useState(data);
    

    useEffect(() => {
        if (data) {
            setDetail(data);
        }
    }, [data]);

    useEffect(() => {
        if (visible) {
            setObservations(data?.observations ?? '');
        }
    }, [data, visible]);

    useEffect(() => {
        // Calcular total actual (prácticas originales o modificadas)
        const basePractices = data?.nomenclators ?? [];
        const modifiedKeys = Object.keys(modifiedPractices);

        const total = basePractices.reduce((sum, p, idx) => {
            const modified = modifiedKeys.includes(String(idx)) ? modifiedPractices[idx] : null;
            return sum + (modified?.totalhonorarium ?? p?.totalhonorarium ?? 0);
        }, 0);

        setDetail(prev => ({ ...prev, totalhonorarium: total }));
    }, [data, modifiedPractices]);




    useEffect(() => {
        getAuditStates()
            .then((states) => {
                let filteredStates = states;
                if (mode === 'audit' || mode === 'editAudit') {
                    filteredStates = states.filter(state => 
                        state.name === 'Aprobado' || 
                        state.name === 'Observado' || 
                        state.name === 'Anulado'
                    );
                }
                
                setAuditStates(filteredStates);
                
                if (mode === 'view' || mode === 'editAudit') {
                    const current = filteredStates.find(s => s.id === (detail.auditstate ?? data.auditstate));
                    if (current) setSelectedAuditState(current);
                } else {
                    setSelectedAuditState(null);
                }
            })
            .catch(console.error);
    }, [detail.auditstate, mode]);

    const handleAuditStateChange = async (e) => {
        if (mode === 'view') {
            setSelectedAuditState(e.value);
            try {
                await updateAuditState(data.professionalattentionlog ?? detail.professionalattentionlog, e.value.id, observations);
                detail.auditstate = e.value.id;
                if (onAuditStateUpdated) onAuditStateUpdated();
            } catch (error) {
                console.error('Error al actualizar el estado de auditoría:', error);
            }
        } else {
            setSelectedAuditState(e.value);
        }
    };

    const handleSaveAudit = async () => {
        if (!selectedAuditState || selectedAuditState.name === 'Pendiente') return;

        try {

            await updateAuditState(
                data.professionalattentionlog ?? detail.professionalattentionlog,
                selectedAuditState.id,
                observations,
            );

            if (Object.keys(modifiedPractices).length > 0) {

                const practicesArray = data.nomenclators.map((p, index) => {
                    const modified = modifiedPractices[index];

                    return {
                        professionalattentionlognomenclators: modified?.professionalattentionlognomenclators
                            ?? p.professionalattentionlognomenclators,
                        nomenclator: modified?.nomenclator ?? p.nomenclator,
                        nomenclatorcode: modified?.nomenclatorcode ?? p.nomenclatorcode,
                        nomenclatordesc: modified?.nomenclatordesc ?? p.nomenclatordesc,
                        billingbyhour: modified?.billingbyhour ?? p.billingbyhour,
                        honorarium: modified?.honorarium ?? p.honorarium ?? 0,
                        billedhours: modified?.billedhours ?? p.billedhours ?? null,
                    };
                });

                await updateAttentionPractices(
                    data.professionalattentionlog ?? detail.professionalattentionlog,
                    practicesArray
                );
            }

            const updatedDetail = await loadProfessionalAttentionLogDetail(
                BigInt(data.professionalattentionlog ?? detail.professionalattentionlog)
            );

            setDetail(updatedDetail);
            setModifiedPractices({});
            if (onAuditStateUpdated) onAuditStateUpdated();

            setTimeout(() => setVisible(false), 150);
        } catch (error) {
            console.error("Error al guardar la auditoría:", error);
        }
    };

    const handleCancelAudit = () => {
        setSelectedAuditState(null);
        setModifiedPractices({});
        setVisible(false);
    };

    function displayAttentions(icon:string, caption:string,realtime:Date | null,statedtime:Date | null,datevalidation:boolean | null,locationvalidation:boolean | null,locationdescription:string | null){
        return (
            <div className='my-2'>
                <p>
                    <b className='flex flex-row'>
                        <img src={icon} alt="icon" style={{ width: '16px', height: '16px', marginRight: '8px' }} />
                        {`${caption}`}
                    </b>
                </p>
                <Divider type='solid' className='h-08px bg-gray-200 m-0' />

                <p style={{paddingLeft:'1.5em'}}><b>{formatDateTime(realtime)}</b>{` ${intl.formatMessage({id:'SystemRegistered'})}`}</p>
                <Divider type='solid' className='h-08px bg-gray-200 m-0' />

                <p style={{color:datevalidation?'#263446':'rgb(251 146 60)', paddingLeft:'1.5em'}}><b>{formatDateTime(statedtime)}</b>{` ${intl.formatMessage({id:'ProfessionalRegistered'})}`}</p>

                <Divider type='solid' className='h-08px bg-gray-200 m-0' />
                {!locationvalidation &&
                <div>
                    <p style={{color:'rgb(251 146 60)', paddingLeft:'1.5em'}}><b>{intl.formatMessage({id:'LocationNotValidated'})}</b></p>
                    <p style={{color:'rgb(251 146 60)', paddingLeft:'1.5em'}}><b>{intl.formatMessage({id:'Motive'})}</b>{(locationdescription != null && (locationdescription.length>1))?` ${locationdescription}`:' - '}</p>
                </div>
                }
                <Divider type='solid' className='h-08px bg-gray-200 m-0' />
            </div>
        );
    }
    
    return (
        <Modal visible={visible} setVisible={setVisible} header={<h6 className="modalTitle"><b>{intl.formatMessage({ id: 'AttentionReport' })}</b>{` ${data?.professionalname}`}</h6>} className='AttentionDetailReportModal min-w-90vw '>
            <div className='grid' style={{ gridTemplateColumns: '1fr 1vw 1fr' }}>
                <div className='flex flex-column gap-2'>
                    <LinedCard header={`${intl.formatMessage({ id: 'PATIENT' })}`}>
                        <div className='my-2'>
                            <p className='flex flex-row align-items-center gap-2'>
                                <b>{data?.patientname}</b>
                                <span> - </span>
                                <img src={"https://cdn.advenio.com.ar/icons/home.png"} alt="icon" style={{ width: '16px', height: '16px', marginRight: '2px' }} />
                                    {`${data?.patientaddress}`}
                            </p>
                            <Divider type='solid' className='h-08px bg-gray-200 m-0' />
                        </div>
                        <div className='my-2'>
                            <p>{data?.patienthealthcoveragedesc}</p>
                            <Divider type='solid' className='h-08px bg-gray-200 m-0' />
                        </div>
                        {detail.patientbenefitnumber && <div className='my-2'>
                            <p>{detail.patientbenefitnumber}</p>
                            <Divider type='solid' className='h-08px bg-gray-200 m-0' />
                        </div>}
                    </LinedCard>
                    <LinedCard header={intl.formatMessage({ id: 'PERFORMEDPRACTICES' })}>
                        
                        <DisplayPractices
                            data={detail?.nomenclators ?? []}
                            mode={mode}
                            duration={detail?.statedminutesworked || detail?.minutesworked || null}
                            referenceDate={detail?.statedarrivalhour || detail?.arrivalhour || null}
                            onPracticeChange={(index, practice, unitRate, total, billedhours) => {
                                const original = detail.nomenclators?.[index];

                                setModifiedPractices(prev => ({
                                    ...prev,
                                    [index]: {
                                        professionalattentionlognomenclators: original?.professionalattentionlognomenclators ?? 0,
                                        nomenclator: practice.nomenclator,
                                        nomenclatorcode: practice.code,
                                        nomenclatordesc: practice.description,
                                        billingbyhour: practice.billingbyhour,
                                        honorarium: unitRate,
                                        totalhonorarium: total,
                                        billedhours: billedhours
                                    }
                                }));
                            }}

                        />
                        {(mode === 'audit' || mode === 'editAudit') && Object.keys(modifiedPractices).length > 0 && (
                                <div className='mt-3 p-3 bg-orange-50 border-1 border-orange-soft border-round-lg'>
                                    <div className='flex align-items-center gap-2'>
                                        <i className='pi pi-exclamation-triangle text-orange-600'></i>
                                        <p className='text-sm text-orange-800 m-0'>
                                            <strong>Se detectaron {Object.keys(modifiedPractices).length} práctica(s) modificada(s). </strong> 
                                            Los cambios se guardarán junto con el estado de auditoría.
                                        </p>
                                    </div>
                                </div>
                            )}
                    </LinedCard>
                    {showHonorarium && (
                        <LinedCard
                            header={
                                <div className="total-header-row">
                                <span className="font-medium">TOTAL HONORARIOS</span>
                                <span className="font-bold text-gray-900">
                                    $ {detail.totalhonorarium?.toLocaleString('es-AR', {
                                    minimumFractionDigits: 2,
                                    maximumFractionDigits: 2,
                                    })}
                                </span>
                                </div>
                            }
                        />
                    )}

                    <div className=''>
                        {/* Observaciones */}
                        <div className='mb-3 max-w-40vw'>
                            <label className='block text-sm font-semibold mb-2'>
                            {intl.formatMessage({ id: 'Observations' })}
                            </label>
                            <InputTextarea
                            value={observations}
                            onChange={(e) => setObservations(e.target.value)}
                            rows={2}
                            className='w-full'
                            placeholder='Ingrese observaciones...'
                            disabled={mode === 'view'}
                            />
                        </div>

                        {/* Auditoría */}
                        <LinedCard header='AUDITORÍA'>
                            <div className='flex align-items-center gap-3 mt-4'>
                                <label className='text-sm font-semibold whitespace-nowrap'>Estado</label>
                                <div className='flex align-items-center gap-3 flex-1'>
                                    <Dropdown
                                        value={selectedAuditState}
                                        options={auditStates}
                                        optionLabel='name'
                                        onChange={handleAuditStateChange}
                                        placeholder='Seleccione un estado'
                                        className={`flex-1 audit-dropdown ${selectedAuditState?.color || ''}`}
                                        panelClassName="audit-dropdown-panel"
                                        disabled={mode === 'view'}
                                        itemTemplate={(option) => (
                                            <div className={`audit-dropdown-item ${option.color}`}>
                                                {option.name}
                                            </div>
                                        )}
                                        valueTemplate={(option) => (
                                            option ? (
                                                <span className={`audit-dropdown-value ${option.color}`}>
                                                    {option.name}
                                                </span>
                                            ) : (
                                                <span>Seleccione un estado</span>
                                            )
                                        )}
                                    />
                                </div>
                            </div>
                        </LinedCard>
                    </div>
                </div>
                <div></div>
                <div className='flex flex-column h-full'>
                    <LinedCard header={<span><b>{intl.formatMessage({ id: 'ATTENTIONDETAIL' })}</b>{`: ${intl.formatMessage({id:detail.leavehour!=null?'FINISHED':'INATTENTION'})}`}</span>}>
                        {displayAttentions(
                            'https://cdn.advenio.com.ar/icons/innit.png',
                            intl.formatMessage({ id: 'Init' }),
                            data?.arrivalhour,
                            data?.statedarrivalhour,
                            data?.arrivaldatevalidated,
                            data?.locationarrivalvalidation,
                            data?.locationarrivaldescription
                        )}

                        {data?.leavehour && displayAttentions(
                            'https://cdn.advenio.com.ar/icons/end.png',
                            intl.formatMessage({ id: 'End' }),
                            data?.leavehour,
                            data?.statedleavehour, 
                            data?.leavedatevalidated,
                            data?.locationleavevalidation,
                            data?.locationleavedescription
                        )}
                    </LinedCard>
                    <GoogleMap
                        className = 'max-w-40vw '
                        mapHeight='225px'
                        center={{lat:detail.patientlat??-1, long:detail.patientlong??-1}} zoom={13}
                        mainMarker={{id:1,position:{lat:detail.patientlat??-1, long:detail.patientlong??-1},icon:'https://cdn.advenio.com.ar/icons/home.png',title:detail.patientname??''}}
                        otherMarkers={[
                            {id:-1, position:{lat:detail.arrivallat??-1, long:detail.arrivallong??-1},icon:'https://cdn.advenio.com.ar/icons/innit.png', title:intl.formatMessage({ id: 'Init' })},
                            {id:-1, position:{lat:detail.leavelat??-1, long:detail.leavelong??-1}, icon:'https://cdn.advenio.com.ar/icons/end.png', title:intl.formatMessage({ id: 'End' })},
                        ]}
                    />
                    <LinedCard header={intl.formatMessage({ id: 'TIMEWORKED' })}>
                        <p><b>{((detail.minutesworked?.length == 4)?'0'+detail.minutesworked:detail.minutesworked + " hs")}</b>{` ${intl.formatMessage({id:'SystemRegistered'})}`}</p>
                        <Divider type='solid' className='h-08px bg-gray-200 m-0' />
                        {detail.statedminutesworked && <p><b>{((detail.statedminutesworked?.length == 4)?'0'+detail.statedminutesworked:detail.statedminutesworked + " hs")}</b>{` ${intl.formatMessage({id:'ProfessionalRegistered'})}`}</p>}
                        <Divider type='solid' className='h-08px bg-gray-200 m-0' />
                    </LinedCard>
                    <LinedCard header={'EVOLUCIONES'}>
                        {detail.medicalEvolutions && detail.medicalEvolutions.length > 0 ? (
                            detail.medicalEvolutions.map((evolution, index) => (
                                <div key={index}>
                                    <p>{evolution.observation}</p>
                                    <Divider type='solid' className='h-08px bg-gray-200 m-0' />
                                </div>
                            ))
                        ) : (
                            <p style={{ color: 'red' }}>Sin evoluciones</p>
                        )}
                    </LinedCard>
                    <div className='mt-6'>
                        {mode === 'view' && detail.auditedby && selectedAuditState?.name !== 'Pendiente' &&(
                                <p className='text-sm text-gray-600 mt-2'>
                                    <strong>Auditó: </strong> {detail.auditedby} - {detail.auditeddate ? formatDateTime(new Date(detail.auditeddate)) : ''}
                                </p>
                        )}
                    </div>
                        
                </div>

            
            </div>
            {(mode === 'audit' || mode === 'editAudit') && (
                <div className='flex justify-content-end gap-2 mt-6'>
                    <Button 
                        label="Cancelar" 
                        className="buttonMain2" 
                        onClick={handleCancelAudit}
                    />
                    <Button 
                        label="Guardar" 
                        className="buttonMain" 
                        onClick={handleSaveAudit}
                        disabled={!selectedAuditState || selectedAuditState.name === 'Pendiente'}
                    />
                </div>
            )}
        </Modal>
    )
}


interface DisplayPracticesProps {
  data: ProfessionalAttentionLogNomenclatorDTO[];
  mode: 'view' | 'audit' | 'editAudit';
  duration: string | null;
  referenceDate: Date | string | null;
  onPracticeChange: (index: number, practice: NomenclatorDTO, unitRate: number, total: number, billedhours: number) => void;
}

function DisplayPractices({ data, mode, duration, referenceDate, onPracticeChange }: DisplayPracticesProps) {
    const { getHonorariums } = useHonorariumService();
    const { getNomenclators } = useEntityService();
    const [editableValues, setEditableValues] = useState<{ [key: number]: { unitRate: string, units: string, locked: boolean } }>({});
    const [selectedPractices, setSelectedPractices] = useState<{ [key: number]: NomenclatorDTO | null }>({});
    const [availablePractices, setAvailablePractices] = useState<NomenclatorDTO[]>([]);

    useEffect(() => {
        const initValues = {};
        const initSelectedPractices = {};

        data.forEach((e, i) => {
            // Cargar SIEMPRE la práctica del paciente aunque valga 0
            const unitRate = e.honorarium ?? 0;
            const isByHour = e.billingbyhour;
            let units: number;
            if (e.billedhours != null && Number(e.billedhours) > 0) {
                units = Number(e.billedhours);
            } else if (isByHour && duration) {
                const [hh, mm] = duration.split(':').map(Number);
                const totalHours = (!isNaN(hh) && !isNaN(mm)) ? hh + mm / 60 : 1;
                units = totalHours < 1 ? 1 : Math.floor(totalHours);
            } else {
                units = 1;
            }
            initValues[i] = {
                unitRate: unitRate.toString(),
                units: units.toString(),
                locked: true
            };


            initSelectedPractices[i] = {
            nomenclator: e.nomenclator,
            code: e.nomenclatorcode,
            description: e.nomenclatordesc,
            codeanddescription: `${e.nomenclatorcode} - ${e.nomenclatordesc}`,
            billingbyhour: e.billingbyhour
            };
        });

        setEditableValues(initValues);
        setSelectedPractices(initSelectedPractices);
    }, [data]);



    useEffect(() => {
        if (mode === 'audit' || mode === 'editAudit') {
            Promise.all([
            getNomenclators({
                filterValue: '',
                offSet: 0,
                pageSize: 50000,
                params: { nomenclatorTypes: [-1], orderByNomenclatorType: false, healthEntity: -1 }
            }).catch(() => []),
            getHonorariums(0, 50000, { referenceDate }).catch(() => [])
            ])
            .then(([nomenclators, honorariums]) => {
                const nomens = Array.isArray(nomenclators) ? nomenclators : [];
                const honors = Array.isArray(honorariums) ? honorariums : [];

                const valued = honors.filter(h => Number(h.value) > 0);

                const merged = nomens
                .map(n => {
                    const h = valued.find(v => v.nomenclatorcode === n.code);
                    if (!h) return null;
                    return {
                    ...n,
                    defaultprice: h.value,
                    billingbyhour: h.billingbyhour
                    };
                })
                .filter(Boolean); 

                const extras = valued
                .filter(h => !nomens.some(n => n.code === h.nomenclatorcode))
                .map(h => ({
                    nomenclator: h.nomenclator,
                    code: h.nomenclatorcode,
                    description: h.nomenclatordesc,
                    codeanddescription: `${h.nomenclatorcode} - ${h.nomenclatordesc}`,
                    defaultprice: h.value,
                    billingbyhour: h.billingbyhour
                }));

                setAvailablePractices([...merged, ...extras]);
            })
            .catch(console.error);
        }
    }, [mode, referenceDate]);


    const handlePracticeChange = (index: number, newPractice: NomenclatorDTO | null) => {
        if (!newPractice) return;
        setSelectedPractices(prev => ({ ...prev, [index]: newPractice }));
        const unitRate = Number(newPractice.defaultprice || 0);
        const currentUnits = parseFloat(editableValues[index]?.units || '1') || 1;
        setEditableValues(prev => ({
            ...prev,
            [index]: { ...prev[index], unitRate: unitRate.toString() }
        }));
        onPracticeChange(index, newPractice, unitRate, unitRate * currentUnits, currentUnits);
    };

    const handleUnitRateChange = (index: number, rawValue: string) => {
        const sanitized = rawValue.replace(/[^\d.]/g, '').replace(/(\..*)\./g, '$1');
        const currentPractice = selectedPractices[index];
        if (!currentPractice) return;
        const unitRate = parseFloat(sanitized) || 0;
        const units = parseFloat(editableValues[index]?.units || '1') || 1;
        setEditableValues(prev => ({
            ...prev,
            [index]: { ...prev[index], unitRate: sanitized }
        }));
        onPracticeChange(index, currentPractice, unitRate, units * unitRate, units);
    };

    const handleUnitsChange = (index: number, rawValue: string) => {
        const sanitized = rawValue.replace(/[^\d.]/g, '').replace(/(\..*)\./g, '$1');
        const currentPractice = selectedPractices[index];
        if (!currentPractice) return;
        const units = parseFloat(sanitized) || 0;
        const unitRate = parseFloat(editableValues[index]?.unitRate || '0') || 0;
        setEditableValues(prev => ({
            ...prev,
            [index]: { ...prev[index], units: sanitized }
        }));
        if (units > 0) {
            onPracticeChange(index, currentPractice, unitRate, units * unitRate, units);
        }
    };



    const toggleLock = (index: number) => {
        setEditableValues(prev => ({
            ...prev,
            [index]: { ...prev[index], locked: !prev[index].locked }
        }));
    };

    return (
        <div>
            {data.map((element, index) => {
                const { unitRate, units, locked } = editableValues[index] || { unitRate: '', units: '1', locked: true };
                const selectedPractice = selectedPractices[index];
                const showDropdown = mode === 'audit' || mode === 'editAudit';
                const isReadOnly = locked || !(mode === 'audit' || mode === 'editAudit');
                const isByHour = selectedPractice?.billingbyhour ?? element.billingbyhour;
                const unitLabel = isByHour ? 'Cantidad de horas' : 'Unidades';
                const unitsInvalid = !isReadOnly && (isNaN(parseFloat(units)) || parseFloat(units) <= 0);

                return (
                    <div key={index} style={{ marginBottom: '0.75rem' }}>
                        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: '12px' }}>
                            <div style={{ flex: 1 }}>
                                {showDropdown ? (
                                    <div className="practice-selector">
                                        <label style={{ display: 'block', fontSize: '0.8rem', fontWeight: 'bold', marginBottom: '4px', color: '#666' }}>
                                            Seleccionar práctica:
                                        </label>
                                        <Combobox
                                            getItems={(getItemsProps) => {
                                                const filteredPractices = availablePractices.filter(p =>
                                                    p.codeanddescription?.toLowerCase().includes(getItemsProps.filterValue?.toLowerCase() || '')
                                                );
                                                return Promise.resolve(
                                                    filteredPractices.slice(getItemsProps.offSet || 0, (getItemsProps.offSet || 0) + (getItemsProps.pageSize || 10))
                                                );
                                            }}
                                            value={selectedPractice}
                                            setValue={(practice: NomenclatorDTO) => handlePracticeChange(index, practice)}
                                            optionLabel="codeanddescription"
                                            placeholder={"Buscar y seleccionar práctica..."}
                                            className={`w-full ${isReadOnly ? 'combobox-locked' : ''}`}
                                            minPanelWidth={500}
                                            maxPanelWidth={700}
                                            disable={isReadOnly}
                                        />
                                    </div>
                                ) : (
                                    <div className="practice-display">
                                        <p style={{ marginBottom: '2px' }}>
                                            <b>Código: {element.nomenclatorcode}</b>
                                        </p>
                                        <p style={{ marginTop: 0 }}>{element.nomenclatordesc}</p>
                                    </div>
                                )}
                            </div>
                            <div style={{ display: 'flex', alignItems: 'flex-end', gap: '8px' }}>
                                <div style={{ display: 'flex', flexDirection: 'column' }}>
                                    <label style={{ fontSize: '0.75rem', color: '#666', marginBottom: '2px', whiteSpace: 'nowrap' }}>
                                        {unitLabel}:
                                    </label>
                                    <input
                                        type='text'
                                        value={units}
                                        onChange={(e) => handleUnitsChange(index, e.target.value)}
                                        disabled={isReadOnly}
                                        className={`practice-input ${isReadOnly ? 'input-locked' : ''} ${unitsInvalid ? 'input-error' : ''}`}
                                        style={{ width: '70px' }}
                                    />
                                    {unitsInvalid && (
                                        <span style={{ fontSize: '0.7rem', color: '#dc3545', marginTop: '2px' }}>Mayor a 0</span>
                                    )}
                                </div>
                                <div style={{ display: 'flex', flexDirection: 'column' }}>
                                    <label style={{ fontSize: '0.75rem', color: '#666', marginBottom: '2px' }}>Importe:</label>
                                    <div style={{ position: 'relative' }}>
                                        <span style={{
                                            position: 'absolute', left: '6px', top: '50%',
                                            transform: 'translateY(-50%)', pointerEvents: 'none',
                                            color: '#666', fontSize: '0.85rem'
                                        }}>$</span>
                                        <input
                                            type='text'
                                            value={unitRate || element.honorarium?.toString() || ''}
                                            onChange={(e) => handleUnitRateChange(index, e.target.value)}
                                            disabled={isReadOnly}
                                            className={`practice-input ${isReadOnly ? 'input-locked' : ''}`}
                                        />
                                    </div>
                                </div>
                                {mode !== 'view' && (
                                    <button
                                        onClick={() => toggleLock(index)}
                                        style={{
                                            width: '28px', height: '28px', borderRadius: '50%',
                                            border: 'none', flexShrink: 0,
                                            backgroundColor: locked ? '#F3F4F5' : '#00b5b8',
                                            display: 'flex', alignItems: 'center',
                                            justifyContent: 'center', cursor: 'pointer'
                                        }}
                                    >
                                        {locked ? (
                                            <i className="pi pi-pencil" style={{ color: '#01717C', fontSize: '13px' }}></i>
                                        ) : (
                                            <i className="pi pi-check" style={{ color: 'white', fontSize: '0.9rem' }}></i>
                                        )}
                                    </button>
                                )}
                            </div>
                        </div>
                        {showDropdown && selectedPractice && (
                            <div className={`practice-display ${selectedPractice.nomenclator !== element.nomenclator ? 'modified' : ''}`} style={{ marginTop: '6px' }}>
                                <p style={{ margin: 0, fontSize: '0.85rem', color: '#666' }}>
                                    {selectedPractice.description}
                                </p>
                            </div>
                        )}
                        <Divider type='solid' className='h-08px bg-gray-200 m-0' />
                    </div>
                );
            })}
        </div>
    );
}
